<template>
  <div class="loader-container" :class="{ 'loader-opaque': isSubmitLoading }">
    <div class="logo-container" ref="logoContainer"></div>
  </div>
</template>

<script>
import lottie from 'lottie-web';
import zerekLoaderAnimate from "@/assets/ZerekLoaderAnimate.json";

export default {
  props: {
    isSubmitLoading: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.initLottieAnimation();
  },
  beforeDestroy() {
    if (this.animation) {
      this.animation.destroy();
    }
  },
  methods: {
    initLottieAnimation() {
      const container = this.$refs.logoContainer;
      if (container) {
        this.animation = lottie.loadAnimation({
          container: container,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: zerekLoaderAnimate
        });
        
        // Опционально: настройки анимации
        this.animation.setSpeed(1);
      }
    }
  }
};
</script>

<style scoped>
.loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 1);
  z-index: 9999;
}

.loader-opaque {
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
}

.logo-container {
  width: 250px;
  height: 250px;
  position: relative;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .logo-container {
    width: 200px;
    height: 200px;
  }
}

@media (max-width: 480px) {
  .logo-container {
    width: 200px;
    height: 200px;
  }
}
</style>